<template>
    <div>
        <div class="tabs_content">
            <ul>
                <li @click="orderjump(1)"><Badge :count="unread.ordernum">业务消息</Badge></li>
                <li @click="orderjump(2)"><Badge :count="unread.helpnum">公司通知公告</Badge></li>
                <li class="active"><Badge :count="unread.msgnum">留言咨询</Badge></li>
            </ul>
        </div>
        <div class="message_content">
            <div class="message_left"><span>留言板</span></div>
            <div class="message_right">
                <div class="message_list">
                    <div v-if="listshow">
                        <ul v-for="(item, index) in messagelist" :key="index">
                            <li class="message_textright">
                                <div class="message_title"><span>我的留言</span><small>{{item.addtime}}</small></div>
                                <div class="message_text">{{item.content}}</div>
                            </li>
                            <li v-if="item.replycontent != null">
                                <div class="message_title"><span>公司回复</span><small>{{item.replytime}}</small><label v-if="item.is_new == 1">新消息</label></div>
                                <div class="message_text">{{item.replycontent}}</div>
                            </li>
                        </ul>
                    </div>
                    <span v-if="notips">暂无留言~</span>
                    <Loadings v-if="loading"></Loadings>
                </div>
                <a href="javascript:;" v-if="messagelist.length > 0" @click="clearpanel">清空留言板</a>
            </div>
        </div>
        <div class="message_content">
            <div class="message_left"><span>回复</span></div>
            <div class="message_right">
                <div class="message_textarea">
                    <Input v-model="message" type="textarea" :rows="4" placeholder="请输入留言咨询内容" />
                </div>
            </div>
        </div>
        <div class="message_btn"><Button type="warning" @click="sendout">发送</Button></div>
        <!-- 清空留言板 -->
        <Modal
            class="agreement_content"
            v-model="clearpanelmodel"
            :width="346"
            :scrollable="false"
            cancel-text="取消"
            ok-text="确定"
            @on-ok="clearpanelOk"
        >
            <div slot="header" class="model_head">
                <span>提示</span>
            </div>
            <div class="model_body">确定删除留言板上的内容吗？</div>
        </Modal>
    </div>
</template>

<script>
import api from '@/request/api.js'
import Loadings from '@/components/component/loading.vue'
export default {
    components: {Loadings},
    data() {
        return {
            loading: false, // 加载中
            listshow: false, // 列表是否显示
            notips: false, // 暂无提示
            unread: { // 未读消息数量
                ordernum: 0,
                helpnum: 0,
                msgnum: 0,
            },
            clearpanelmodel: false, // 清空留言弹窗是否显示
            messagelist: [], // 留言列表
            message: '', // 提交留言信息
        }
    },
    methods: {
        getInfo () { // 获取订单详情
            this.listshow = false
            this.notips = false
            this.loading = true
            this.http.post(api.message, {type: 3})
            .then(response => {
                console.log(response.data.msg)
                this.unread = response.data.msg.num
                this.messagelist = response.data.msg.msglist
                this.loading = false
                response.data.msg.msglist.length > 0 ? this.listshow = true : this.notips = true
            })
            .catch(error => {
                console.log(error);
            })
        },
        delmessage () { // 清空留言
            this.http.post(api.delmessage, {type: 2})
            .then(response => {
                console.log(response.data.msg)
                this.$Message.success('已清空留言!')
                this.getInfo()
            })
            .catch(error => {
                this.$Message.error(error)
            })
        },
        addmessage () { // 添加留言
            this.http.post(api.addmessage + '&content=' + this.message)
            .then(response => {
                console.log(response.data.msg)
                this.$Message.success('留言提交成功！')
                this.getInfo()
                this.message = ''
            })
            .catch(error => {
                this.$Message.error(error)
            })
        },
        sendout () { // 添加留言
            this.addmessage()
        },
        orderjump (sign) { // 跳转页面
            let link
            if (sign == 1) {
                link = '/Notice'
            } else if (sign == 2) {
                link = '/News'
            } else {
                link = '/Message'
            }
            this.$router.push(link)
        },
        clearpanel () { // 清空留言按钮
            this.clearpanelmodel = true
        },
        clearpanelOk () { // 确认清空留言记录
            this.delmessage()
            this.clearpanelmodel = false
        }
    },
    created () {
        this.getInfo()
    }
}
</script>

<style scoped>

.message_content {
    display: flex;
    flex-direction: row;
    padding: 10px 20px 10px 0;
}

.message_left {
    width: 80px;
    flex-grow: 0;
    flex-shrink: 0;
    padding-right: 20px;
    text-align: right;
}

.message_left > span {
    margin-top: 6px;
    font-size: 13px;
    color: #0C1F6D;
    display: block;
}

.message_right {
    width: 10px;
    flex-grow: 1;
    flex-shrink: 1;
}

.message_right > a {
    margin-top: 4px;
    font-size: 14px;
    color: #999;
    display: inline-block;
}

.message_list {
    width: 100%;
    max-height: 320px;
    background-color: #fafafa;
    overflow: auto;
}

.message_list > span {
    padding: 20px 0;
    text-align: center;
    font-size: 14px;
    color: #999;
    display: block;
}

.message_list ul > li {
    padding: 10px 20px;
    border-bottom: 1px solid #f2f2f2;
}

.message_list ul > li:last-child {
    border-bottom: none;
}

.message_textright {
    text-align: right;
}

.message_title > span {
    font-size: 12px;
    color: #666;
}

.message_title > small {
    margin-left: 10px;
    font-size: 12px;
    color: #999;
}

.message_title > label {
    padding: 0 3px;
    margin-left: 10px;
    font-size: 12px;
    color: #FF8000;
    border: 1px solid #FF8000;
    border-radius: 2px;
}

.message_text {
    padding-top: 4px;
    font-size: 12px;
    color: #333;
    word-break: break-all;
}

.message_btn {
    text-align: center;
}

.message_btn > button {
    min-width: 80px;
    height: 34px;
}

</style>


// WEBPACK FOOTER //
// src/components/views/news/message.vue